var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTraitCardImg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(-770 -3097)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2588",
    "data-name": "Rectangle 2588",
    width: 115,
    height: 115,
    transform: "translate(770 3097)",
    fill: "#a6c49d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2589",
    "data-name": "Rectangle 2589",
    width: 100,
    height: 45,
    transform: "translate(778 3106)",
    fill: "#17e7b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2590",
    "data-name": "Rectangle 2590",
    width: 100,
    height: 45,
    transform: "translate(778 3158)",
    fill: "#ef962c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraitCardImg4);
export default __webpack_public_path__ + "static/media/traitCardImg4.ac729273dd39416ab3783706dcb3624c.svg";
export { ForwardRef as ReactComponent };